export function extractResourceName (arn) {
  if (!arn) return null
  const parts = arn.split(':')
  return parts[parts.length - 1] || arn
}
